import React from 'react';
import PropTypes from 'prop-types';
import NHTable from '../../../common/NHTable';
import NHSelect from '../../../common/NHSelect';
import NHFetch from "../../../../utils/NHFetch";
import { Button } from 'antd';
import css from './index.css';
import getSize from "../../../../utils/getSize";
import { hasAuth } from "../../../../utils/NHCore";

/**
 * @author weishihuai
 * @date 2018/8/21
 * @time 16:31
 * @Description: 自助报到统计 - 查询公共Tab
 */
export default class ZzbdtjCommonTab extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchXslb:'',
            searchBm:'',
        }
    }

    componentWillMount = () => {
        NHFetch('/tjcx/zzbdblcx' + '/SelectFirstHJDM', 'GET')
            .then(res => {
                if (res && res.data != null) {
                    this.setState({ searchText: res.data },() => {
                        this.refs.nhTable.filterTableData();
                    })
                }
            }).catch(err => {
            });
    }

    //下拉框改变事件监听
    handleSelect = (value) => {
        this.setState({
            searchText: value
        }, () => {
            this.refs.nhTable.filterTableData();
        })
    }

    //下拉框改变事件监听
    handleSelectXslb = (value) => {
        this.setState({
            searchXslb: value
        }, () => {
            this.refs.nhTable.filterTableData();
        })
    }

    //下拉框改变事件监听
    handleSelectBm = (value) => {
        this.setState({
            searchBm: value
        }, () => {
            this.refs.nhTable.filterTableData();
        })
    }

    render() {
        const { sign, columns, exportClickListener,bmSelectShow,xslbSelectShow } = this.props;
        const sqlParams = {
            HJDM: this.state.searchText,
            xslbm:this.state.searchXslb,
            bmid:this.state.searchBm,
        }
        
        return (
            <div className={css.main_right_content} style={{ height: getSize().windowH - 220 }}>
                <div style={{ marginBottom: "10px", width: '100%' }}>
                    <span style={{ float: 'left', marginLeft: '12px', padding: '7px 0 20px 0' }}>环节名称：</span>
                    <NHSelect
                        style={{ float: 'left', width: "200px", display: 'inline' }}
                        sign={"zhxg_yxxt_tjcx_zzbdtj"}
                        onChange={this.handleSelect}
                        value={this.state.searchText}
                    />
                    {
                        bmSelectShow?
                            <div>
                                <span style={{ float: 'left', marginLeft: '12px', padding: '7px 0 20px 10px' }}>院系：</span>
                                <NHSelect
                                    style={{ float: 'left', width: "200px", display: 'inline' }}
                                    sign={"zhxg_academy"}
                                    onChange={this.handleSelectBm}
                                    value={this.state.searchBm}
                                />
                            </div>
                            :
                            ""
                    }
                    {
                        xslbSelectShow?
                            <div>
                                <span style={{ float: 'left', marginLeft: '12px', padding: '7px 0 20px 10px' }}>学生类别：</span>
                                <NHSelect
                                    style={{ float: 'left', width: "200px", display: 'inline' }}
                                    sign={"zhxg_yxxt_tjcx_zzbdtj_xslb"}
                                    onChange={this.handleSelectXslb}
                                    value={this.state.searchXslb}
                                />
                            </div>
                            :
                            ""
                    }
                </div>
                <div style={{ clear: 'both',width:"100%",height:"90%" }}>
                    <NHTable
                        ref='nhTable'
                        sign={sign}
                        columns={columns}
                        checkbox={false}
                        searchDivFlag={false}
                        sqlParams={sqlParams}
                    >
                        {hasAuth("zhxg_yxgl_tjcx_zzbdtjcx:export") &&
                            <Button type="primary" ghost onClick={() => exportClickListener(this.refs.nhTable)}
                                style={{ marginLeft: 10 }}>导出</Button>}
                    </NHTable>
                </div>
            </div >
        );
    }

}

ZzbdtjCommonTab.propTypes = {
    columns: PropTypes.array,
    sign: PropTypes.string,
    exportClickListener: PropTypes.func
};




// WEBPACK FOOTER //
// ./components/tjcx/zzbdtjcx/jxZzbdtjcx/zzbdtjCommonTab.js